import log from 'loglevel';

log.setLevel('info'); // trace | debug | info | warn | error

export default log;